import React from "react";
import { Facebook, Instagram, Twitter } from "lucide-react";

export default function Footer(){
  return (
    <footer className="mt-16 bg-black border-t border-white/5 py-10 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          <h4 className="font-bold text-white">ShopAt1Stop</h4>
          <p className="text-sm mt-2 text-gray-400">Curated accessories & premium picks for enthusiasts.</p>
        </div>

        <div>
          <h5 className="font-semibold text-white">Quick Links</h5>
          <ul className="mt-3 text-sm text-gray-400 space-y-2">
            <li>About</li>
            <li>Products</li>
            <li>Contact</li>
          </ul>
        </div>

        <div>
          <h5 className="font-semibold text-white">Address</h5>
          <p className="text-sm text-gray-400 mt-2">123 Market Street, City</p>
          <p className="text-sm text-gray-400">hello@shopat1stop.com</p>
        </div>

        <div>
          <h5 className="font-semibold text-white">Follow</h5>
          <div className="flex gap-3 mt-3 text-gray-300">
            <Facebook size={18}/>
            <Instagram size={18}/>
            <Twitter size={18}/>
          </div>
        </div>
      </div>

      <div className="mt-8 text-center text-sm text-gray-500">© {new Date().getFullYear()} ShopAt1Stop. Designed with 💨</div>
    </footer>
  );
}
